<div>
    <a class="btn qa-vInCue-btn" href="#" title="{{'vinCueCreateAppraisalButtonText' | translate}}" (click)="vincueModal()">
        <img src="../../../../images/vincue_wordmark_black.svg" style="height:22px;width:auto;" />
    </a>
</div>
